export const initHamburger = () => {
  const hamburgerTriggers: NodeListOf<HTMLButtonElement> | null =
    document.querySelectorAll('.js-hamburger-trigger');
  const hamburgerMenu: HTMLDialogElement | null = document.querySelector('.js-hamburger-menu');

  if (!hamburgerMenu) {
    return;
  }

  const hamburgerClickListener = () => {
    if (hamburgerMenu.open) {
      hamburgerMenu.classList.add('close');

      setTimeout(() => {
        hamburgerMenu.close();
      }, 300);

      return;
    }

    hamburgerMenu.showModal();
    document.body.style.overflow = 'hidden';
  };

  hamburgerTriggers.forEach((hamburgerTrigger) => {
    hamburgerTrigger.addEventListener('click', hamburgerClickListener);
  });

  hamburgerMenu.addEventListener('close', () => {
    document.body.style.overflow = '';
    hamburgerMenu.classList.remove('close');
  });

  // Resize window listener
  window.addEventListener('resize', () => {
    if (window.innerWidth > 1280) {
      hamburgerMenu.close();
    }
  });
};
